import { Component, Input, OnInit } from '@angular/core';
import { Offer, OfferItem } from 'src/app/classes';

@Component({
  selector: 'app-offer-preview',
  templateUrl: './offer-preview.component.html',
  styleUrls: ['./offer-preview.component.css']
})
export class OfferPreviewComponent implements OnInit {

  @Input() offer: Offer;

  subTitles: string[] = [];

  constructor() { }

  ngOnInit(): void {
    if(this.offeritems.length === 0) this.subTitles.push("Dieses Angebot enthält keine Artikel");
    else {
      this.subTitles.push(...[
        `Dieses Angebot enthält ${this.offeritems.length} Artikel`,
        `Summe Mietpreis: ${this.offeritems.reduce((agg, curr) => agg += curr.itemrentalcost, 0).toFixed(2).replace('.', ',')} €`,
        `Summe Einrichtung: ${this.offeritems.reduce((agg, curr) => agg += curr.itemsetupcost, 0).toFixed(2).replace('.', ',')} €`,
        `Summe Kaufpreis: ${this.offeritems.reduce((agg, curr) => agg += curr.itempurchasecost, 0).toFixed(2).replace('.', ',')} €`
      ]);
    }
  }

  get offeritems(): OfferItem[] {
    return this.offer && Array.isArray(this.offer.offeritem)? this.offer.offeritem: [];
  }

}
